import { getPropertyURL } from "@/utils/propertyNavigation";
import { memo, useMemo } from "react";

const CfdTitleHeader = ({ item, onNavigatePDP, isMapCard, activeTab }) => {
  const isSavedTab = activeTab === "saved";
  // Destructure based on activeTab to avoid redundant property access
  const {
    streetNumber = "",
    streetName = "",
    city = "",
    state = "",
    zip = "",
  } = isSavedTab
    ? item?.propertyDetails?.address || {}
    : item?.propAddress || {};

  // Memoized location string to prevent unnecessary recalculations
  const location = useMemo(() => {
    return (
      `${streetNumber} ${streetName}`.trim() +
      `, ${city}, ${state} ${zip}`.trim()
    );
  }, [streetNumber, streetName, city, state, zip]);

  const propertyId = item?.propertyDetails?.propertyId || item?.propertyId;
  const category = item?.propertyDetails?.commonAttributes?.propCategory || item?.propertyCategory;
  const propertyStatus = item?.propertyDetails?.commonAttributes?.status || item?.propertyStatus;
  const listingUrl = item?.propertyListingDetails?.listingUrl || item?.listingUrl;
  const listingId = item?.propertyListingDetails?.listingId || item?.listingId;

  return (
    <>
      {item?.agentCompanyName && (
        <div className="cfd-details-title">
          Listed by {item.agentCompanyName}
        </div>
      )}
      {item?.type && <p className="text-thm">{item.type}</p>}
      <div className={`cursor-pointer ${isMapCard ? "pt10 pb10" : "pb5"}`}>
        <span className="cfd-details-location-title">
          <a
            href={getPropertyURL(`/property/${listingId || propertyId}`, category, propertyStatus)}
            onClick={(e) => {
              e.preventDefault();
              onNavigatePDP();
            }}
          >
            {location}
          </a>
        </span>
      </div>
    </>
  );
};

export default memo(CfdTitleHeader);
